import {
  UserOptionsMenuItems,
  UserOptionsMenuItemsWithTranslationConfig,
} from '../types';

import type { useTranslateMessage } from './translate-messages';

export function getLocalizedMenuSections(
  config: UserOptionsMenuItemsWithTranslationConfig,
  translateMessage: ReturnType<typeof useTranslateMessage>
): UserOptionsMenuItems {
  return Object.fromEntries(
    Object.entries(config).map(([key, section]) => [
      key,
      {
        text:
          section.defaultText === '' || !section.textId
            ? ''
            : translateMessage({
                id: section.textId,
                defaultMessage: section.defaultText,
              }),
        items: section.items.map((item) => ({
          text: translateMessage({
            id: item.textId,
            defaultMessage: item.defaultText,
          }),
          url: item.url,
          ...(item.badge && { badge: item.badge }),
        })),
      },
    ])
  ) as UserOptionsMenuItems;
}
